import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmar-dialog',
  templateUrl: './confirmar-dialog.component.html',
  styleUrls: ['./confirmar-dialog.component.scss']
})
export class ConfirmarDialogComponent {
  title: string;
  info: string;
  button?: string;
  hideCancelButton?: boolean;
  disableClose?: boolean = false;

  constructor(private dialogRef: MatDialogRef<ConfirmarDialogComponent>) {
    const data = inject(MAT_DIALOG_DATA) as {
      title: string;
      info: string;
      button?: string;
      hideCancelButton?: boolean;
      disableClose?: boolean;
    };
    this.title = data.title;
    this.info = data.info;
    this.button = data.button;
    this.hideCancelButton = data.hideCancelButton;
    this.disableClose = data.disableClose !== undefined ? data.disableClose : undefined;
    this.disableClose ? (this.dialogRef.disableClose = true) : null;
  }

  confirmar() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close();
  }

  stringAceptar() {
    return this.button ? this.button : 'dialog_confirm.buttons.ok';
  }
}
